import {
  ListCard,
  ListIconWrapper,
  BodyContainer,
  RightMainContainer,
  HeaderContainer,
  PrimaryHeading,
  InputField,
  LoadingListCards,
} from "commonUI";
import { MailIcon } from "allIcons";
import { useEmailTemplates } from "hooks/emailTemplates";
import { t } from "i18next";
import { isEqual } from "helpers";

export default function EmailTemplate() {
  const { data: emailTemplates, isLoading: loadingEmailTemplates } =
    useEmailTemplates();

    return (
    <>
      <RightMainContainer>
        <HeaderContainer>
          <PrimaryHeading>{t("accountSettings.emailTemplates.title")}</PrimaryHeading>
        </HeaderContainer>
        <BodyContainer>
          <InputField
            searchIcon
            placeholder={t("input.search.placeholder")}
            sort
          />
          {loadingEmailTemplates ? (
            <LoadingListCards />
          ) : (
            emailTemplates.map((template, index) => {
              return (
                <ListCard
                  data={template.email_title}
                  secondaryData={
                    isEqual(template.system_status, 1) ? t("module.sourceType.system") : ""
                  }
                  key={index}
                  index={index}
                  link={`/account-settings/email-templates/${template.id}`}
                  deleteIcon={true}
                  strictLink
                  icon={
                    <ListIconWrapper>
                      <MailIcon />
                    </ListIconWrapper>
                  }
                />
              );
            })
          )}
        </BodyContainer>
      </RightMainContainer>
    </>
  );
}
